import { defineComponent } from 'navigation-components/platform/models';
import { CHATSPOT_SIDEBAR_COMPONENT, Tags } from '../constants';
import { getIframeSrc, getStyle } from './internal';
import { capabilities } from '../../capabilities';
import { args } from '../../common/args';
// We know this function won't always work, it's wrapped in a try/catch but we
// want to slowly adopt this new behavior as apps adopt quartz.
// @bend-expect quartz-outside-quartz See above
import { getCopilotLayoutType as getCopilotLayoutFromQuartz } from 'quartz-core/framework/copilot';
const COPILOT_SIDEBAR_CLASS = '.copilot-sidebar-container';
const QUARTZ_SIDEBAR_CLASS = '.quartz-grid-sidebar-container';
const COPILOT_THREAD_ID_QUERY_PARAM = 'copilotThreadId';
function getCopilotThreadIdParam() {
  const urlQueryParams = new URLSearchParams(window.location.search);
  return urlQueryParams.get(COPILOT_THREAD_ID_QUERY_PARAM) || '';
}
const getShouldStartOpen = () => {
  try {
    // Local storage key for whether Copilot was previously open when the page loaded (i.e. open after a page reload)
    // Values can be one of the following integers: 0 | 1 | 2
    // 0 = closed | 1 = open | 2 = open expanded view
    const copilotInitialOpenSessionStorageValue = sessionStorage.getItem('copilot-initialize-open');
    return copilotInitialOpenSessionStorageValue === '1' || copilotInitialOpenSessionStorageValue === '2';
  } catch (e) {
    return false;
  }
};
const getCopilotLayoutType = () => {
  // Since not all apps use quartz this won't always be set, we just want to use
  // it if it is
  try {
    return getCopilotLayoutFromQuartz();
  } catch (e) {
    // We don't want to default this here. It will override the value from the
    // channel if we do.
    return undefined;
  }
};
export const chatspotSidebarComponentDef = defineComponent(CHATSPOT_SIDEBAR_COMPONENT, () => {
  const copilotSidebar = document.querySelector(COPILOT_SIDEBAR_CLASS) || document.querySelector(QUARTZ_SIDEBAR_CLASS);
  return {
    name: CHATSPOT_SIDEBAR_COMPONENT,
    src: getIframeSrc(),
    capabilities: [capabilities.UPSERT_GLOBAL_STYLES_CAP.getName(), capabilities.RESTYLE_CAP.getName(), capabilities.HIDE_COMPONENT_CAP.getName(), capabilities.SHOW_COMPONENT_CAP.getName(), capabilities.UPDATE_QUERY_PARAM_CAP.getName()],
    deferLoading: false,
    initiallyOpen: getShouldStartOpen(),
    propsSchema: {
      isSearchOpen: args.optional(args.bool()),
      threadIdQueryParam: args.optional(args.string()),
      copilotLayoutType: args.optional(args.string())
    },
    iframeProps: {
      style: getStyle()
    },
    initialProps: {
      isSearchOpen: false,
      threadIdQueryParam: getCopilotThreadIdParam(),
      copilotLayoutType: getCopilotLayoutType()
    },
    renderTo: () => copilotSidebar,
    tags: [Tags.SIDE_PANEL]
  };
});